import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Slider = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other}>
			<path
				d="M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,7.3478351 18.9464316,4.80429597 17.0710678,2.92893219 C15.195704,1.0535684 12.6521649,0 10,0 Z M7.5,13.125 L6.25,14.375 L1.875,10 L6.25,5.625 L7.5,6.875 L4.375,10 L7.5,13.125 Z M13.75,14.375 L12.5,13.125 L15.625,10 L12.5,6.875 L13.75,5.625 L18.125,10 L13.75,14.375 Z"
				id="slider"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Slider.propTypes = {
	color: PropTypes.string,
};

export default Slider;
